module.exports = __webpack_public_path__ + "img/Product Principal List.dc12913b.png";